export const BILLING_UNITS = Object.freeze([
    { code: 'cubicmeters', labelKey: '§calc.step1.billing_options.cubicmeters' },
    { code: 'hours', labelKey: '§calc.step1.billing_options.hours' },
    { code: 'kw', labelKey: '§calc.step1.billing_options.kw' },
    { code: 'kwh', labelKey: '§calc.step1.billing_options.kwh' },
    { code: 'other', labelKey: '§calc.step1.billing_options.other' },
    { code: 'pallets', labelKey: '§calc.step1.billing_options.pallets' },
    { code: 'picks', labelKey: '§calc.step1.billing_options.picks' },
    { code: 'pieces', labelKey: '§calc.step1.billing_options.pieces' },
    { code: 'runningmeters', labelKey: '§calc.step1.billing_options.runningmeters' },
    { code: 'sheets', labelKey: '§calc.step1.billing_options.sheets' },
    { code: 'squaremeters', labelKey: '§calc.step1.billing_options.squaremeters' },
    { code: 'tons', labelKey: '§calc.step1.billing_options.tons' },
    { code: 'washes', labelKey: '§calc.step1.billing_options.washes' },
])

export const BILLING_UNIT_CODES = Object.freeze(BILLING_UNITS.map((u) => u.code))

export const BILLING_DROPDOWN_OPTIONS = Object.freeze(
    BILLING_UNITS.map((u) => ({ value: u.code, label: u.labelKey })),
)
